import ReactDOM from 'react-dom/client';
import '@fontsource-variable/plus-jakarta-sans';
import '@fontsource-variable/fraunces';
import App from './App';
import './styles/global.css';
import { watchSky } from './lib/sky';
import { migrateLegacyStorage } from './lib/storage';

migrateLegacyStorage();
watchSky();

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
